import { fromNode } from '@rehaje/core'
import { reactive } from '@rehaje/reactive'

import { ValuableModel } from '../../models'

import type { SchemaNode } from '../../models'
import type { SchemaFunctionNode } from './TypedNode'

export class SchemaFunctionModel extends ValuableModel<
  Function,
  SchemaFunctionNode
> {
  @fromNode()
  @reactive('shallow')
  additionalParameters?: SchemaNode

  @fromNode()
  @reactive()
  async: boolean = false

  @fromNode()
  @reactive()
  generator: boolean = false

  @fromNode()
  @reactive('shallow')
  parameters: SchemaNode[] = []

  @fromNode()
  @reactive()
  return?: SchemaNode
}

declare global {
  export interface RehajeViewModels {
    'Schema.Function': SchemaFunctionModel
  }
}
